<form #createMessageForm="ngForm" class="emds facility-portal" (ngSubmit)="send()" novalidate>
  <div class="modal-default modal-flex">
    <div class="modal-header">
      {{'New ' | translate}} {{messageSubTypeName}} {{' Message' | translate}}
      <ap-spinner *ngIf="modalLoading" class="modal-header-spinner" size="1"></ap-spinner>
    </div>

    <div class="modal-body">
      <ap-alert></ap-alert>
      <div *ngIf="hasError">
        <alert type="danger" translate>
          An error has occurred. {{errorMessage}}
          <button type="button" class="close" data-dismiss="alert">
            <span>&times;</span>
          </button>
        </alert>
      </div>
      <div class="flex-row">
        <!-- Patient -->
        <div class="flex-item form-group">
          <label class="active">{{'Patient' | translate}}</label>
          <ap-findcontrol
            [baseId]="Id + '-facility-portal-patient'"
            [additionalSearchParameters]="patientFindControlAdditionalSearchParams"
            [findControlId]="findControlIdService.FacilityPortalPatient"
            [findControlDisplayName]="'Patient'"
            [(selectedPks)]="selectedFpPatientIds"
            [placeHolder]=""
            [disabled]="false"
            [singleSelect]="true"
            [required]="true"
            [form]="createMessageForm"
            (chipsChange)="getReadOnlyFields($event)">
          </ap-findcontrol>
        </div>

        <!-- Service Site -->
        <div class="flex-item form-group">
          <label class="active">{{'Service Site' | translate}}</label>
          <ap-findcontrol
            [baseId]="Id + '-service-site'"
            [findControlId]="findControlIdService.FacilityServiceSite"
            [(selectedPks)]="selectedServiceSiteIds"
            [placeHolder]=""
            [disabled]="true"
            [singleSelect]="false">
          </ap-findcontrol>
        </div>

        <!-- Program -->
        <div class="flex-item form-group">
          <label class="active">{{'Program' | translate}}</label>
          <ap-findcontrol
            [baseId]="Id + '-patient-program'"
            [findControlId]="findControlIdService.FacilityPatientProgram"
            [(selectedPks)]="selectedPatientProgramIds"
            [placeHolder]=""
            [disabled]="true"
            [singleSelect]="false">
          </ap-findcontrol>
        </div>
      </div>
      <div class="flex-row">
        <!-- Practice Provider -->
        <div class="flex-item form-group">
          <label class="active">{{'Practice Provider' | translate}}</label>
          <input id="{{Id}}-practice-provider" class="form-control" type="text" name="practiceprovider"
            [(ngModel)]="practiceProvider" (input)="updatePracticeProvider($event.target.value)" disabled>
        </div>

        <!-- Due Date -->
        <div class="flex-item form-group">
          <ap-date-picker
            [baseId]="Id + '-duedate'"
            [required]="false"
            name="{{inputNames.duedate}}"
            [labelName]="'Due Date'"
            [(ngModel)]="dueDate">
          </ap-date-picker>
        </div>

        <!-- Assign To-->
        <div class="flex-item form-group">
          <label class="active">{{'Assign To' | translate}}</label>
          <ap-findcontrol
            [baseId]="Id + '-assign-to-find-control'"
            [findControlId]="findControlIdService.FacilityPortalMessageRouting"
            [findControlDisplayName]="'Assign To'"
            [(selectedPks)]="selectedToUserAndUserGroupIds"
            [additionalSearchParameters]="assignToAdditionalSearchParams"
            [placeHolder]=""
            [disabled]="false"
            [singleSelect]="false"
            [required]="true"
            [form]="createMessageForm">
          </ap-findcontrol>
        </div>
      </div>
      <div class="flex-row">
        <!-- Subtype -->
        <div class="flex-item form-group">
          <label class="active">{{'Subtype' | translate}}</label>
          <ap-findcontrol
            [baseId]="Id + '-subtype-find-control'"
            [additionalSearchParameters]="subtypeAdditionSearchParameters"
            [findControlId]="findControlIdService.ListMessageSubType"
            [(selectedPks)]="subtypeSelected"
            [placeHolder]=""
            [disabled]="subtypeDisabled"
            [singleSelect]="true"
            [required]="true"
            [form]="createMessageForm"
            (chipsChange)="subtypeChanged($event)">
          </ap-findcontrol>
        </div>

        <!-- Attachment -->
        <div class="flex-item form-group" *ngIf="maxFiles && maxFiles > 0">
          <label class="active">{{'Attachment' | translate}}</label>
          <ap-file-upload
            [baseId]="Id + '-attachments'"
            (filesChanged)="filesChanged($event)"
            [allowedExtensions]="allowedExtensions"
            [fileSizeLimit]="fileSizeLimit"
            [maxFiles]="maxFiles"
            (errorOutput)="displayError($event)"
            [required]="attachmentsRequired"
            [form]="createMessageForm"
            [fileUploadControlDisplayName]="'Attachment'">
          </ap-file-upload>
        </div>

        <!-- Urgency-->
        <div class="flex-item form-group">
          <label class="active">{{'Urgency' | translate}}</label>
          <ap-findcontrol
            [baseId]="Id + '-urgency'"
            [findControlId]="findControlIdService.ListMessageUrgency"
            [(selectedPks)]="messageUrgencySelected"
            [placeHolder]=""
            [singleSelect]="true"
            [required]="true"
            [form]="createMessageForm">
          </ap-findcontrol>
        </div>
      </div>
      <div class="flex-row">
        <!-- Subject -->
        <div class="flex-item form-group">
          <label class="active">{{'Subject' | translate}}</label>
          <input id="{{Id}}-message-subject" class="form-control" type="text" name="subject"
            [(ngModel)]="messageSubject"
            (input)="updateMessageSubject($event.target.value)"
            [apRequired]="getSubjectRequired()"
            [disabled]="getSubjectDisabled()"
            autocomplete="off">
        </div>
        <!-- From -->
        <div class="flex-item form-group">
          <label class="active">{{'From' | translate}}</label>
          <input
            id="{{Id}}-From"
            class="form-control"
            type="text"
            name="fromUserName"
            [(ngModel)]="fromUserName"
            disabled>
        </div>
      </div>

      <!-- Enter A Message -->
      <div class="flex-item form-group">
        <label class="active">{{'Enter A Message' | translate}}</label>
        <ap-html-text-editor
          [(ngModel)]="messageBody"
          name="messageBody"
          [height]="120"
          [hideToolbar]="true"
          [hideStatusBar]="true"
          [editorName]="'enterAMessage'"
          [required]="true"
          [displayName]="'Enter A Message'"
          #apHtmlTextEditor>
        </ap-html-text-editor>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn-primary btn" [disabled]="sendingMessage" translate>
        <span translate [hidden]="sendingMessage">Send</span>
        <ap-spinner *ngIf="sendingMessage" size="1"></ap-spinner>
      </button>
      <button type="button" class="btn btn-secondary" [disabled]="sendingMessage" (click)="cancel()"
        translate>Cancel</button>
    </div>
  </div>
</form>
